import * as i0 from '@angular/core';
import { forwardRef, Component, Input, Output, Directive, Attribute, ElementRef, HostListener, ViewChildren, EventEmitter, HostBinding, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { aciAdd, aciSub, aciClose, aciInfo } from '@am/common-svg-icons';
import { Subject, Subscription } from 'rxjs';
import * as i3 from '@am/moebius';
import { MbIconModule, MbCheckboxModule, MbButtonModule, MbFormFieldModule } from '@am/moebius';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ComponentPortal } from '@angular/cdk/portal';

class PassengersDialogSelectorComponent {
    constructor() {
        this._value = 0;
        this.change = new Subject();
        this.minValue = 0;
    }
    set value(value) {
        this.setValue(value);
    }
    get value() {
        return this._value;
    }
    setValue(value, shouldEmit = false) {
        if (value < this.minValue) {
            this._value = this.minValue;
        }
        else if (value > this.maxValue) {
            this._value = this.maxValue;
        }
        else {
            this._value = value || 0;
        }
        if (shouldEmit && this.oldValue !== this.value) {
            this.oldValue = this.value;
            this.change.next(this.value);
            this.propagateChanges && this.propagateChanges(this.value);
        }
    }
    handleManipulationValue(addition) {
        this.value += addition ? 1 : -1;
        this.setValue(this.value, true);
    }
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) { }
    writeValue(value) {
        if (value || value === 0) {
            this.setValue(value, true);
        }
    }
}
/** @nocollapse */ PassengersDialogSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ PassengersDialogSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PassengersDialogSelectorComponent, selector: "am-passengers-dialog-selector", inputs: { helpText: "helpText", title: "title", minValue: "minValue", maxValue: "maxValue", error: "error", value: "value" }, outputs: { change: "change" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => PassengersDialogSelectorComponent)),
            multi: true
        }
    ], ngImport: i0, template: "<div class=\"selector__wrapper\">\n  <div class=\"selector__description\">\n    <span class=\"selector__description-title no-selectable\">{{title}}<ng-content *ngIf=\"!title\"></ng-content></span>\n    <span *ngIf=\"helpText\" class=\"selector__description-help-text\">{{ helpText }}</span>\n  </div>\n  <div class=\"selector__content\">\n    <mb-icon (click)=\"handleManipulationValue(false)\"\n             (keydown.enter)=\"handleManipulationValue(false)\"\n             (keydown.space)=\"handleManipulationValue(false)\"\n             class=\"selector__content-icon\"\n             data-au=\"minus\"\n             icon=\"PassengersDialog:sub\"\n             id=\"subtraction\"\n             role=\"button\"\n             tabindex=\"0\"></mb-icon>\n    <div class=\"selector__content-label no-selectable\" [ngClass]=\"{ 'selector__content-label--error' : error }\" data-au=\"value\">{{value}}</div>\n    <mb-icon (click)=\"handleManipulationValue(true)\"\n             (keydown.enter)=\"handleManipulationValue(true)\"\n             (keydown.space)=\"handleManipulationValue(true)\"\n             class=\"selector__content-icon\"\n             data-au=\"plus\"\n             icon=\"PassengersDialog:add\"\n             id=\"add\"\n             role=\"button\"\n             tabindex=\"0\">\n    </mb-icon>\n  </div>\n</div>\n", styles: [":host .no-selectable{-webkit-user-select:none;user-select:none}:host .selector__wrapper{align-items:center;display:flex}:host .selector__description{color:var(--color-gray-800);display:flex;flex:1 50%;flex-direction:column;font-family:ProximaNova,sans-serif;font-size:1rem;font-stretch:normal;font-style:normal;letter-spacing:normal}:host .selector__description-title{font-weight:600}:host .selector__description-description-help-text{font-weight:400}:host .selector__content{align-items:inherit;display:flex;flex-grow:1;justify-content:space-between;width:95px}:host .selector__content-icon{border:1px solid transparent;cursor:pointer}:host .selector__content-icon.mb-icon{color:var(--color-secondary);font-size:1.875rem;line-height:0}:host .selector__content-icon:focus,:host .selector__content-icon--focus{border:1px solid var(--color-secondary-light);border-radius:100%;outline:none}:host .selector__content-label{color:var(--color-gray-900);font-size:1.25rem;font-weight:600}:host .selector__content-label--error{color:var(--color-error)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MbIcon, selector: "mb-icon", inputs: ["icon", "horizontalFlip", "verticalFlip", "spin"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: "am-passengers-dialog-selector", providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => PassengersDialogSelectorComponent)),
                            multi: true
                        }
                    ], template: "<div class=\"selector__wrapper\">\n  <div class=\"selector__description\">\n    <span class=\"selector__description-title no-selectable\">{{title}}<ng-content *ngIf=\"!title\"></ng-content></span>\n    <span *ngIf=\"helpText\" class=\"selector__description-help-text\">{{ helpText }}</span>\n  </div>\n  <div class=\"selector__content\">\n    <mb-icon (click)=\"handleManipulationValue(false)\"\n             (keydown.enter)=\"handleManipulationValue(false)\"\n             (keydown.space)=\"handleManipulationValue(false)\"\n             class=\"selector__content-icon\"\n             data-au=\"minus\"\n             icon=\"PassengersDialog:sub\"\n             id=\"subtraction\"\n             role=\"button\"\n             tabindex=\"0\"></mb-icon>\n    <div class=\"selector__content-label no-selectable\" [ngClass]=\"{ 'selector__content-label--error' : error }\" data-au=\"value\">{{value}}</div>\n    <mb-icon (click)=\"handleManipulationValue(true)\"\n             (keydown.enter)=\"handleManipulationValue(true)\"\n             (keydown.space)=\"handleManipulationValue(true)\"\n             class=\"selector__content-icon\"\n             data-au=\"plus\"\n             icon=\"PassengersDialog:add\"\n             id=\"add\"\n             role=\"button\"\n             tabindex=\"0\">\n    </mb-icon>\n  </div>\n</div>\n", styles: [":host .no-selectable{-webkit-user-select:none;user-select:none}:host .selector__wrapper{align-items:center;display:flex}:host .selector__description{color:var(--color-gray-800);display:flex;flex:1 50%;flex-direction:column;font-family:ProximaNova,sans-serif;font-size:1rem;font-stretch:normal;font-style:normal;letter-spacing:normal}:host .selector__description-title{font-weight:600}:host .selector__description-description-help-text{font-weight:400}:host .selector__content{align-items:inherit;display:flex;flex-grow:1;justify-content:space-between;width:95px}:host .selector__content-icon{border:1px solid transparent;cursor:pointer}:host .selector__content-icon.mb-icon{color:var(--color-secondary);font-size:1.875rem;line-height:0}:host .selector__content-icon:focus,:host .selector__content-icon--focus{border:1px solid var(--color-secondary-light);border-radius:100%;outline:none}:host .selector__content-label{color:var(--color-gray-900);font-size:1.25rem;font-weight:600}:host .selector__content-label--error{color:var(--color-error)}\n"] }]
        }], propDecorators: { helpText: [{
                type: Input
            }], change: [{
                type: Output
            }], title: [{
                type: Input
            }], minValue: [{
                type: Input
            }], maxValue: [{
                type: Input
            }], error: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class LabelMessageComponent {
    constructor() {
        this.options = {
            smallMarginBottom: false,
            hasError: false,
            flexVerticallyCenter: false,
            isSecondary: false
        };
        this.message = {};
    }
    set secondary(value) {
        this.options.isSecondary = value;
    }
    set smallMarginBottom(value) {
        this.options.smallMarginBottom = coerceBooleanProperty(value);
    }
    set hasError(value) {
        this.options.hasError = coerceBooleanProperty(value);
    }
    set flexVerticallyCenter(value) {
        this.options.flexVerticallyCenter = coerceBooleanProperty(value);
    }
    get type() {
        return this.activeMessage ? this.dynamicType : this.defaultType;
    }
    get activeMessage() {
        return Object.keys(this.message).find(key => this.message[key]);
    }
}
/** @nocollapse */ LabelMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LabelMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ LabelMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LabelMessageComponent, selector: "am-label-message", inputs: { secondary: "secondary", dynamicType: "dynamicType", defaultType: "defaultType", message: "message", smallMarginBottom: ["small-margin-bottom", "smallMarginBottom"], hasError: ["has-error", "hasError"], flexVerticallyCenter: ["flex-vertically-center", "flexVerticallyCenter"] }, ngImport: i0, template: "<span\n  [ngClass]=\"{\n        'label--icon': !!type,\n        'label--info': type == 'info',\n        'label--error': type == 'error' || options.hasError,\n        'label--small-margin-bottom': options.smallMarginBottom,\n        'label--vertically-center': options.flexVerticallyCenter,\n        'label--secondary': options.isSecondary\n    }\"\n  class=\"label\">\n    <ng-template #content>\n        <ng-content></ng-content>\n    </ng-template>\n    <ng-container\n      *ngIf=\"activeMessage; else content\"\n      i18n=\"@@passengersDialog-labelMessage\">\n        {\n          activeMessage,\n          select,\n          errorMessageRequired { Este campo es obligatorio }\n          adultPerChildError { Debe viajar 1 adulto por infante }\n          }\n    </ng-container>\n</span>\n", styles: ["@charset \"UTF-8\";:host .label{color:var(--color-gray-dark);display:inline-block;font-family:ProximaNova,sans-serif;font-size:.875rem;font-stretch:normal;font-style:normal;font-weight:400;margin-bottom:5px;-webkit-user-select:none;user-select:none}:host .label:empty{display:none}:host .label--secondary{color:var(--color-secondary);font-size:1rem;font-weight:600;letter-spacing:normal}:host .label--icon{align-items:center;display:flex;font-size:.875rem}:host .label--icon:before{align-items:center;border-radius:100%;color:var(--color-white);content:none;display:flex;font-weight:700;height:16px;justify-content:center;margin-right:4px;min-width:16px}:host .label--icon:before:empty{display:none}:host .label--icon.label--info:before{background:var(--color-notification);content:\"i\"}:host .label--icon.label--error{color:var(--color-error)}:host .label--icon.label--error:before{background:var(--color-error);content:\"\\2716\"}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LabelMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-label-message', template: "<span\n  [ngClass]=\"{\n        'label--icon': !!type,\n        'label--info': type == 'info',\n        'label--error': type == 'error' || options.hasError,\n        'label--small-margin-bottom': options.smallMarginBottom,\n        'label--vertically-center': options.flexVerticallyCenter,\n        'label--secondary': options.isSecondary\n    }\"\n  class=\"label\">\n    <ng-template #content>\n        <ng-content></ng-content>\n    </ng-template>\n    <ng-container\n      *ngIf=\"activeMessage; else content\"\n      i18n=\"@@passengersDialog-labelMessage\">\n        {\n          activeMessage,\n          select,\n          errorMessageRequired { Este campo es obligatorio }\n          adultPerChildError { Debe viajar 1 adulto por infante }\n          }\n    </ng-container>\n</span>\n", styles: ["@charset \"UTF-8\";:host .label{color:var(--color-gray-dark);display:inline-block;font-family:ProximaNova,sans-serif;font-size:.875rem;font-stretch:normal;font-style:normal;font-weight:400;margin-bottom:5px;-webkit-user-select:none;user-select:none}:host .label:empty{display:none}:host .label--secondary{color:var(--color-secondary);font-size:1rem;font-weight:600;letter-spacing:normal}:host .label--icon{align-items:center;display:flex;font-size:.875rem}:host .label--icon:before{align-items:center;border-radius:100%;color:var(--color-white);content:none;display:flex;font-weight:700;height:16px;justify-content:center;margin-right:4px;min-width:16px}:host .label--icon:before:empty{display:none}:host .label--icon.label--info:before{background:var(--color-notification);content:\"i\"}:host .label--icon.label--error{color:var(--color-error)}:host .label--icon.label--error:before{background:var(--color-error);content:\"\\2716\"}\n"] }]
        }], propDecorators: { secondary: [{
                type: Input
            }], dynamicType: [{
                type: Input
            }], defaultType: [{
                type: Input
            }], message: [{
                type: Input
            }], smallMarginBottom: [{
                type: Input,
                args: ['small-margin-bottom']
            }], hasError: [{
                type: Input,
                args: ['has-error']
            }], flexVerticallyCenter: [{
                type: Input,
                args: ['flex-vertically-center']
            }] } });

class SelectorValidatorDirective {
    set selectorChanges(value) {
        if (this._onChange)
            this._onChange();
    }
    constructor(validateSelector) {
        this.validateSelector = validateSelector;
    }
    validate(control) {
        const controlValue = control.value;
        if (!controlValue) {
            return { selectorRequired: true };
        }
        if (this.validateSelector === 'guests') {
            const guestsValidation = this.context.options.adultPerInfant &&
                (this.room.adults < this.context.rooms[this.roomIndex].children) &&
                (this.context.infants[this.roomIndex].indexOf(this.childIndex) + 1 > this.room.adults);
            if (guestsValidation) {
                return { adultPerChild: true };
            }
        }
        return null;
    }
    registerOnValidatorChange(fn) { this._onChange = fn; }
}
/** @nocollapse */ SelectorValidatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SelectorValidatorDirective, deps: [{ token: 'validateSelector', attribute: true }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SelectorValidatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: SelectorValidatorDirective, selector: "[amValidateSelector][formControlName],[amValidateSelector][formControl],[amValidateSelector][ngModel]", inputs: { context: "context", room: "room", roomIndex: "roomIndex", childIndex: "childIndex", selectorChanges: "selectorChanges" }, providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef((() => SelectorValidatorDirective)), multi: true }
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SelectorValidatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amValidateSelector][formControlName],[amValidateSelector][formControl],[amValidateSelector][ngModel]',
                    providers: [
                        { provide: NG_VALIDATORS, useExisting: forwardRef((() => SelectorValidatorDirective)), multi: true }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['validateSelector']
                }] }]; }, propDecorators: { context: [{
                type: Input
            }], room: [{
                type: Input
            }], roomIndex: [{
                type: Input
            }], childIndex: [{
                type: Input
            }], selectorChanges: [{
                type: Input
            }] } });

class PassengersDialogComponent {
    constructor() {
        this.allowFocus = false;
        /**
         * Value observable
         */
        this.value$ = new Subject();
        /**
         * Close observable
         */
        this.close$ = new Subject();
    }
    /**
     * Binds keydown escape(27) event
     * @param event keydown event
     */
    keydown(event) {
        const ESCAPE_KEY = 27;
        if (this.dialogType && event.which === ESCAPE_KEY) {
            this.handleDoneButtonClick();
        }
    }
    ngAfterViewInit() {
        if (this.allowFocus) {
            const selectorList = this.queryList;
            selectorList.first.nativeElement.querySelector("#subtraction").focus();
        }
    }
    /**
     * Set dialog type
     * @param dialogType Dialog type
     * @param options dialog options
     */
    setType(dialogType, options = {}) {
        if (dialogType) {
            this.context = { $implicit: dialogType };
            dialogType.setOptions(options);
            dialogType.registerOnChange(value => this.emitValue(value));
            dialogType.setValue(this.value);
            this.dialogType = dialogType;
            this.currentDialogType = dialogType.getType();
        }
    }
    /**
     * Emit value to directive
     * @param value value to emit
     */
    emitValue(value) {
        if (value) {
            this.value = value;
        }
        const inputValue = this.dialogType.getInputValue();
        this.value$.next({ value: this.value, total: 0, inputValue });
    }
    /**
     * Handles done button click
     */
    handleDoneButtonClick() {
        if (this.dialogType.canClose()) {
            this.close$.next(true);
        }
    }
    /**
     * Handles close button click
     */
    close() {
        if (this.dialogType.canClose()) {
            this.close$.next(true);
        }
    }
}
/** @nocollapse */ PassengersDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ PassengersDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PassengersDialogComponent, selector: "am-passengers-dialog", host: { listeners: { "keydown": "keydown($event)" } }, viewQueries: [{ propertyName: "queryList", predicate: ["selectorWrapper"], descendants: true, read: ElementRef }], ngImport: i0, template: "<div attr.data-au=\"passengers-dialog-{{ currentDialogType }}\" class=\"passengers-dialog {{ currentDialogType }}\">\n  <div class=\"passengers-dialog__close\" (click)=\"close()\">X</div>\n  <div class=\"passengers-dialog__triangle\"></div>\n  <div class=\"passengers-dialog__content\">\n    <ng-container [ngSwitch]=\"currentDialogType\">\n      <ng-container *ngSwitchCase=\"'guests'\">\n        <ng-container *ngTemplateOutlet=\"guestsTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'flights'\">\n        <ng-container *ngTemplateOutlet=\"flightsTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'assistance'\">\n        <ng-container *ngTemplateOutlet=\"assistanceTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'cruises'\">\n        <ng-container *ngTemplateOutlet=\"cruisesTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'circuits'\">\n        <ng-container *ngTemplateOutlet=\"circuitsTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <p>Invalid dialog type</p>\n      </ng-container>\n    </ng-container>\n  </div>\n  <div class=\"passengers-dialog__footer\">\n    <hr />\n    <button (click)=\"handleDoneButtonClick()\" class=\"done-button\" color=\"secondary\" data-au=\"done\"\n      i18n=\"@@passengersDialog-ok\" mb-button variant=\"principal\">Listo</button>\n  </div>\n</div>\n\n<!-- Guests -->\n<ng-template #guestsTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.roomsChange($event)\" [(ngModel)]=\"ctrl.selectedRooms\"\n      [maxValue]=\"ctrl.statics.MAX_ROOMS\" [minValue]=\"ctrl.statics.MIN_ROOMS\" data-au=\"room\"\n      i18n-title=\"@@passengersDialog-rooms\" title=\"Habitaciones\"></am-passengers-dialog-selector>\n  </div>\n  <div *ngFor=\"let room of ctrl.rooms; let roomIndex = index; let last = last\" class=\"selector__wrapper\">\n    <hr />\n    <am-label-message [secondary]=\"true\" i18n=\"@@passengersDialog-guestsForRoom\">\n      <span>Habitaci\u00F3n {{ roomIndex + 1 }}</span>\n    </am-label-message>\n    <div class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'adults', $event)\" [(ngModel)]=\"room.adults\"\n        [maxValue]=\"ctrl.statics.MAX_ADULTS\" [minValue]=\"ctrl.statics.MIN_ADULTS\" attr.data-au=\"adults-{{ roomIndex }}\"\n        helpText=\"A partir de 18 a\u00F1os*\" i18n-helpText=\"@@passengersDialog-from18Age\"\n        i18n-title=\"@@passengersDialog-adult\" title=\"Mayores\"></am-passengers-dialog-selector>\n    </div>\n    <div class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'children', $event)\"\n        [(ngModel)]=\"room.children\" [maxValue]=\"ctrl.statics.MAX_CHILDREN\" [minValue]=\"ctrl.statics.MIN_CHILDREN\"\n        attr.data-au=\"children-{{ roomIndex }}\" helpText=\"Hasta 17 a\u00F1os\" i18n-helpText=\"@@passengersDialog-to17Age\"\n        i18n-title=\"@@passengersDialog-menores\" title=\"Menores\"></am-passengers-dialog-selector>\n    </div>\n    <div class=\"selector__messages\">\n      <am-label-message *ngIf=\"ctrl.showMaxPassengersAlert[roomIndex]\" defaultType=\"info\"\n        i18n=\"@@passengersDialog-maxGuestsReachedAlert\">L\u00EDmite de personas por habitaci\u00F3n alcanzado.</am-label-message>\n    </div>\n    <div *ngIf=\"ctrl.rooms[roomIndex].children\" class=\"selector\">\n      <div class=\"selector__messages\">\n        <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-guestChildAge\">Edad que tendr\u00E1 al finalizar el\n          viaje.</am-label-message>\n      </div>\n      <ng-container *ngFor=\"let child of room.childrenAges; let childIndex = index; let last = last\">\n        <div [ngClass]=\"{ last: last }\" class=\"selector__container\">\n          <mb-form-field appearance=\"light\">\n            <label for=\"child-{{ childIndex }}\" mb-form-field-label i18n=\"@@passengersDialog-menorAge\">Edad del menor\n              *</label>\n            <select #selector=\"ngModel\" (change)=\"ctrl.guestsChange(roomIndex, childIndex, child.value)\"\n              [(ngModel)]=\"child.value\" [childIndex]=\"childIndex\" [context]=\"ctrl\" [roomIndex]=\"roomIndex\" [room]=\"room\"\n              [selectorChanges]=\"!(value$ | async)\" amValidateSelector attr.data-au=\"age-child-{{ roomIndex }}\"\n              class=\"age-selector\" id=\"child-{{ childIndex }}\" mb-form-field-input role=\"listbox\" tabindex=\"0\"\n              validateSelector=\"guests\">\n              <option disabled hidden i18n=\"@@passengersDialog-selectAge\" selected value>Selecciona la edad</option>\n              <option *ngFor=\"let option of ctrl.statics.CHILDREN_AGES; let optionIndex = index\" [value]=\"optionIndex\">\n                {{ option }}</option>\n            </select>\n            <ng-container>\n              <mb-success *ngIf=\"selector.valid\"></mb-success>\n            </ng-container>\n\n            <mb-error *ngIf=\"(ctrl.dialogIsDirty && selector.invalid) || (selector.dirty && selector.invalid)\">\n              <ng-container *ngIf=\"selector.errors?.selectorRequired\"\n                i18n=\"@@passengersDialog-requiredErrorMessage\">Este campo es obligatorio</ng-container>\n\n              <ng-container *ngIf=\"selector.errors?.adultPerChild\"\n                i18n=\"@@passengersDialog-adultPerChildErrorMessage\">Debe viajar 1 adulto por menor</ng-container>\n            </mb-error>\n          </mb-form-field>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Circuits -->\n<ng-template #circuitsTemplate let-ctrl>\n  <div class=\"selector selector--hr\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.roomsChange($event)\" [(ngModel)]=\"ctrl.selectedRooms\"\n      [maxValue]=\"ctrl.maxRooms()\" [minValue]=\"ctrl.statics.MIN_ROOMS\" data-au=\"room\"\n      i18n-title=\"@@passengersDialog-rooms\" title=\"Habitaciones\">\n    </am-passengers-dialog-selector>\n    <div class=\"nessages\">\n      <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-maxOccupation\">Hasta {{\n        ctrl.statics.MAX_PASSENGERS_PER_ROOM }} personas por habitaci\u00F3n.</am-label-message>\n    </div>\n  </div>\n  <ng-container *ngFor=\"let room of ctrl.rooms; let roomIndex = index\">\n    <hr />\n    <am-label-message [secondary]=\"true\" i18n=\"@@passengersDialog-guestsForRoom\">\n      <span>Habitaci\u00F3n {{ roomIndex + 1 }}</span>\n    </am-label-message>\n    <div [ngClass]=\"{ 'selector--without-message': !(room.adults === 1 && room.children === 0) }\" class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'adults', $event)\" [(ngModel)]=\"room.adults\"\n        [maxValue]=\"ctrl.maxAdults(roomIndex)\" [minValue]=\"ctrl.statics.MIN_ADULTS\"\n        attr.data-au=\"adults-{{ roomIndex }}\" helpText=\"A partir de 18 a\u00F1os*\"\n        i18n-helpText=\"@@passengersDialog-from18Age\" i18n-title=\"@@passengersDialog-adult\" title=\"Mayores\">\n      </am-passengers-dialog-selector>\n    </div>\n    <div *ngIf=\"room.adults === 1 && room.children === 0\" class=\"shared-room\">\n      <label class=\"shared-room__checkbox\">\n        <mb-checkbox [(ngModel)]=\"room.shared\" attr.data-au=\"shared-{{ roomIndex }}\"></mb-checkbox>\n        <span i18n=\"@@passengersDialog-sharingRoom\">Compartir habitaci\u00F3n con alguien del mismo sexo</span>\n      </label>\n    </div>\n    <div class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'children', $event)\"\n        [(ngModel)]=\"room.children\" [maxValue]=\"ctrl.maxChildren(roomIndex)\" [minValue]=\"ctrl.statics.MIN_CHILDREN\"\n        attr.data-au=\"children-{{ roomIndex }}\" i18n-title=\"@@passengersDialog-menores\" title=\"Menores\"\n        helpText=\"Hasta 17 a\u00F1os\" i18n-helpText=\"@@passengersDialog-to17Age\">\n      </am-passengers-dialog-selector>\n    </div>\n    <div *ngIf=\"ctrl.rooms[roomIndex].children\" class=\"selector\">\n      <div class=\"selector__messages\">\n        <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-guestChildAge\">Edad que tendr\u00E1 al finalizar el\n          viaje.</am-label-message>\n      </div>\n      <ng-container *ngFor=\"let child of room.childrenAges; let childIndex = index; let last = last\">\n        <div [ngClass]=\"{ last: last }\" class=\"selector__container\">\n          <mb-form-field appearance=\"light\">\n            <label for=\"child-{{ childIndex }}\" mb-form-field-label i18n=\"@@passengersDialog-menorAge\">Edad del\n              menor</label>\n            <select #selector=\"ngModel\" (change)=\"ctrl.updateDirtyStatus()\" [(ngModel)]=\"child.value\" [context]=\"ctrl\"\n              [selectorChanges]=\"!(value$ | async)\" amValidateSelector attr.data-au=\"age-child-{{ roomIndex }}\"\n              class=\"age-selector\" id=\"child-{{ childIndex }}\" mb-form-field-input role=\"listbox\" tabindex=\"0\">\n              <option disabled hidden i18n=\"@@passengersDialog-selectAge\" selected value>Selecciona la edad</option>\n              <option *ngFor=\"let option of ctrl.statics.CHILDREN_AGES; let optionIndex = index\" [value]=\"optionIndex\">\n                {{ option }}</option>\n            </select>\n            <ng-container>\n              <mb-success *ngIf=\"selector.valid\"></mb-success>\n            </ng-container>\n\n            <mb-error *ngIf=\"(ctrl.dialogIsDirty && selector.invalid) || (selector.dirty && selector.invalid)\">\n              <ng-container *ngIf=\"selector.errors?.selectorRequired\"\n                i18n=\"@@passengersDialog-requiredErrorMessage\">Este campo es obligatorio</ng-container>\n            </mb-error>\n          </mb-form-field>\n        </div>\n      </ng-container>\n    </div>\n  </ng-container>\n</ng-template>\n\n<!-- Flights -->\n<ng-template #flightsTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.adultsChange($event)\" [(ngModel)]=\"ctrl.adults\"\n      [maxValue]=\"ctrl.maxAdults\" [minValue]=\"ctrl.statics.MIN_ADULTS\" data-au=\"adults\" helpText=\"A partir de 18 a\u00F1os*\"\n      i18n-helpText=\"@@passengersDialog-from18Age\" i18n-title=\"@@passengersDialog-newAdults\" title=\"Adultos\"\n      role=\"dialog\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.youngAdultsChange($event)\" [(ngModel)]=\"ctrl.youngAdults\"\n      [maxValue]=\"ctrl.maxYoungAdults\" [minValue]=\"ctrl.statics.MIN_YOUNG_ADULTS\" data-au=\"youngAdults\"\n      helpText=\"De 12 a 17 a\u00F1os\" i18n-helpText=\"@@passengersDialog-from12To17Age\"\n      i18n-title=\"@@passengersDialog-youngAdults\" title=\"Adultos j\u00F3venes\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.childrenChange($event)\" [(ngModel)]=\"ctrl.children\"\n      [maxValue]=\"ctrl.maxChildren\" [minValue]=\"ctrl.statics.MIN_CHILDREN\" data-au=\"children\" helpText=\"De 2 a 11 a\u00F1os\"\n      i18n-helpText=\"@@passengersDialog-children\" i18n-title=\"@@passengersDialog-childrenTitle\" title=\"Ni\u00F1os\">\n    </am-passengers-dialog-selector>\n  </div>\n\n\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.babiesChange($event)\" [(ngModel)]=\"ctrl.babies\"\n      [maxValue]=\"ctrl.maxBabies\" [minValue]=\"ctrl.statics.MIN_BABIES\" [error]=\"ctrl.BabiesValidation\" data-au=\"babies\"\n      helpText=\"Menos de 2 a\u00F1os*\" i18n-helpText=\"@@passengersDialog-lessThan2\" i18n-title=\"@@passengersDialog-babies\"\n      title=\"Beb\u00E9s\">\n    </am-passengers-dialog-selector>\n  </div>\n  <ng-container>\n    <div class=\"flights_messages\">\n      <div *ngIf=\"ctrl.BabiesValidation\" class=\"flights_messages--item maxPerAdult\">\n        <mb-icon icon=\"PassengersDialog:close\"></mb-icon>\n        <span i18n=\"@@passengersDialog-maxAdultsPerBabies\" class=\"flights_messages--text\">Debe viajar 1 adulto por\n          bebe.</span>\n      </div>\n      <div *ngIf=\"ctrl.babies\" class=\"flights_messages--item info\">\n        <mb-icon icon=\"PassengersDialog:info\"></mb-icon>\n        <span i18n=\"@@passengersDialog-guestChildAge\" class=\"flights_messages--text\">Edad que tendr\u00E1 al finalizar el\n          viaje.</span>\n      </div>\n      <div *ngIf=\"ctrl.showMaxPassengersAlert\" class=\"flights_messages--item info\">\n        <mb-icon icon=\"PassengersDialog:info\"></mb-icon>\n        <span i18n=\"@@passengersDialog-maxPassengerReachedaAlert\" class=\"flights_messages--text\">Hasta {{\n          ctrl.statics.MAX_PASSENGERS }} personas por reserva.</span>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>\n\n<!-- Cruises-->\n<ng-template #cruisesTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.adultsChange($event)\" [(ngModel)]=\"ctrl.adults\"\n      [maxValue]=\"ctrl.maxAdults\" [minValue]=\"ctrl.statics.MIN_ADULTS\" data-au=\"adults\" helpText=\"A partir de 18 a\u00F1os*\"\n      i18n-helpText=\"@@passengersDialog-from18Age\" i18n-title=\"@@passengersDialog-adult\" title=\"Mayores\" role=\"dialog\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.childrenChange($event)\" [(ngModel)]=\"ctrl.children\"\n      [maxValue]=\"ctrl.maxChildren\" [minValue]=\"ctrl.statics.MIN_CHILDREN\" data-au=\"children\" helpText=\"De 2 a 17 a\u00F1os*\"\n      i18n-helpText=\"@@passengersDialog-from2To17Age\" i18n-title=\"@@passengersDialog-menores\" title=\"Menores\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div *ngIf=\"ctrl.children\" class=\"selector last\">\n    <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-guestChildAge\">\n      Edad que tendr\u00E1 al finalizar el viaje.</am-label-message>\n    <ng-container *ngFor=\"let child of ctrl.childrenAges; let childIndex = index\">\n      <div class=\"selector__container\">\n        <mb-form-field appearance=\"light\">\n          <label for=\"child-{{ childIndex }}\" mb-form-field-label i18n=\"@@passengersDialog-menorAge\">Edad del\n            menor</label>\n          <select #selector=\"ngModel\" (change)=\"ctrl.updateDirtyStatus()\" [(ngModel)]=\"child.value\" [context]=\"ctrl\"\n            [selectorChanges]=\"!(value$ | async)\" amValidateSelector class=\"age-selector\" data-au=\"age-child\"\n            id=\"child-{{ childIndex }}\" mb-form-field-input role=\"listbox\" tabindex=\"0\">\n            <option disabled hidden i18n=\"@@passengersDialog-selectAge\" selected value>Selecciona la edad\n            </option>\n            <option *ngFor=\"let option of ctrl.statics.CHILDREN_AGES; let optionIndex = index\" [value]=\"optionIndex\">{{\n              option }}</option>\n          </select>\n          <ng-container>\n            <mb-success *ngIf=\"selector.valid\"></mb-success>\n          </ng-container>\n\n          <mb-error *ngIf=\"(ctrl.dialogIsDirty && selector.invalid) || (selector.dirty && selector.invalid)\">\n            <ng-container *ngIf=\"selector.errors?.selectorRequired\" i18n=\"@@passengersDialog-requiredErrorMessage\">Este\n              campo es obligatorio</ng-container>\n          </mb-error>\n        </mb-form-field>\n      </div>\n    </ng-container>\n  </div>\n\n  <div class=\"selector__messages\">\n    <am-label-message *ngIf=\"ctrl.isCruises\" defaultType=\"info\" i18n=\"@@passengersDialog-maxOccupationPassengers\">Hasta\n      {{ ctrl.statics.MAX_PASSENGERS }} pasajeros.</am-label-message>\n  </div>\n</ng-template>\n\n<!-- Assistance -->\n<ng-template #assistanceTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.passengersChange('young', $event)\"\n      [(ngModel)]=\"ctrl.young\" [maxValue]=\"ctrl.maxYoung\" [minValue]=\"ctrl.minYoung\" data-au=\"young\"\n      helpText=\"De 0 a 20 a\u00F1os\" i18n-helpText=\"@@passengersDialog-from0To20Age\" i18n-title=\"@@passengersDialog-young\"\n      title=\"J\u00F3venes\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.passengersChange('adults', $event)\" [(ngModel)]=\"ctrl.adults\"\n      [maxValue]=\"ctrl.maxAdults\" [minValue]=\"ctrl.minAdults\" data-au=\"adults\" helpText=\"De 21 a 69 a\u00F1os\"\n      i18n-helpText=\"@@passengersDialog-from21To69Age\" i18n-title=\"@@passengersDialog-adults\" title=\"Adultos\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.passengersChange('oldPeople', $event)\" [(ngModel)]=\"ctrl.oldPeople\"\n      [maxValue]=\"ctrl.maxOldPeople\" [minValue]=\"ctrl.minOldPeople\" data-au=\"oldPeople\" helpText=\"+70 a\u00F1os\"\n      i18n-helpText=\"@@passengersDialog-mais70Age\" i18n-title=\"@@passengersDialog-older\" title=\"Mayores\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector last--icon\">\n    <am-label-message *ngIf=\"ctrl.showMaxPassengersAlert\" defaultType=\"info\"\n      i18n=\"@@passengersDialog-maxPassengerReachedaAlert\">Hasta {{ ctrl.maxPassengers }} personas por\n      reserva.</am-label-message>\n  </div>\n</ng-template>\n", styles: ["@media only screen and (max-width: 767px){::ng-deep .am-panel-passengers-dialog{inset:0!important;position:absolute!important}}:host .passengers-dialog{background-color:var(--color-white);border:solid 1px var(--color-gray);border-radius:4px;display:flex;flex-direction:column;margin:8px 0;padding:16px;position:relative;width:290px}:host .passengers-dialog__triangle{border-bottom:7px solid var(--color-gray);border-left:12px solid transparent;border-right:12px solid transparent;height:0;left:5px;position:absolute;top:-7px;width:0}:host .passengers-dialog__triangle:before{border-bottom:6px solid var(--color-white);border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:0;left:-10px;position:absolute;top:1px;width:0}@media only screen and (max-width: 767px){:host .passengers-dialog__triangle{display:none}}:host .passengers-dialog hr{border:.0315rem solid var(--color-gray);margin:0 0 15px;width:100%}:host .passengers-dialog hr.last{margin-bottom:15px}:host .passengers-dialog__close{display:none}@media only screen and (max-width: 767px){:host .passengers-dialog__close{align-self:flex-start;cursor:pointer;display:block;font-size:1.3rem;font-weight:400;line-height:1;margin-bottom:10px}}@media only screen and (max-width: 767px){:host .passengers-dialog__content{overflow-y:scroll;padding-bottom:70px}}:host .passengers-dialog.circuits .shared-room{align-items:center;display:flex;font-size:.875rem;margin-bottom:5px}:host .passengers-dialog.circuits .shared-room__checkbox{display:flex}:host .passengers-dialog .selector{margin-bottom:15px}:host .passengers-dialog .selector__container{margin-bottom:15px}:host .passengers-dialog .selector__container.last{margin-bottom:0}:host .passengers-dialog .selector--without-message{margin-bottom:5px}:host .passengers-dialog .selector--hr{margin-bottom:10px}:host .passengers-dialog .selector.last{margin-bottom:0}:host .passengers-dialog .selector.last--icon{margin-bottom:10px}:host .passengers-dialog .flights_messages{margin-top:-7px;margin-bottom:19px}:host .passengers-dialog .flights_messages--item{display:flex;align-items:center;margin:6px 0}:host .passengers-dialog .flights_messages--item:first-child{margin-top:0}:host .passengers-dialog .flights_messages--item:last-child{margin-bottom:0}:host .passengers-dialog .flights_messages .maxPerAdult{color:var(--color-error);margin-bottom:4px}:host .passengers-dialog .flights_messages .info mb-icon{color:var(--color-notification-dark)}:host .passengers-dialog .flights_messages--text{margin-left:4px;font-size:14px}:host .passengers-dialog__footer{align-items:center;display:flex;flex-direction:column;justify-content:center}:host .passengers-dialog__footer .done-button{min-width:112px}:host .passengers-dialog__footer .done-button:focus,:host .passengers-dialog__footer .done-button--focus{border:3px solid var(--color-secondary-light);outline:none}@media only screen and (max-width: 767px){:host .passengers-dialog__footer{background-color:var(--color-white);bottom:16px;left:16px;position:absolute;right:16px}}@media only screen and (max-width: 767px){:host .passengers-dialog{border-radius:0;height:100%;margin:0;width:100%}}@media only screen and (max-width: 767px){:host{width:100%}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3.MbIcon, selector: "mb-icon", inputs: ["icon", "horizontalFlip", "verticalFlip", "spin"] }, { kind: "component", type: i3.MbCheckbox, selector: "mb-checkbox", inputs: ["disabled", "value", "id", "name", "tabIndex"], outputs: ["valueChange"] }, { kind: "component", type: i3.MbButton, selector: "button[mb-button]", inputs: ["variant", "color", "disabled", "loading"] }, { kind: "component", type: i3.MbFormField, selector: "mb-form-field", inputs: ["appearance", "loading"] }, { kind: "directive", type: i3.MbFormFieldLabel, selector: "label[mb-form-field-label]" }, { kind: "directive", type: i3.MbFormFieldSelect, selector: "select[mb-form-field-input]" }, { kind: "component", type: i3.MbFormFieldSuccess, selector: "mb-success" }, { kind: "component", type: i3.MbFormFieldError, selector: "mb-error" }, { kind: "component", type: PassengersDialogSelectorComponent, selector: "am-passengers-dialog-selector", inputs: ["helpText", "title", "minValue", "maxValue", "error", "value"], outputs: ["change"] }, { kind: "component", type: LabelMessageComponent, selector: "am-label-message", inputs: ["secondary", "dynamicType", "defaultType", "message", "small-margin-bottom", "has-error", "flex-vertically-center"] }, { kind: "directive", type: SelectorValidatorDirective, selector: "[amValidateSelector][formControlName],[amValidateSelector][formControl],[amValidateSelector][ngModel]", inputs: ["context", "room", "roomIndex", "childIndex", "selectorChanges"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: "am-passengers-dialog", template: "<div attr.data-au=\"passengers-dialog-{{ currentDialogType }}\" class=\"passengers-dialog {{ currentDialogType }}\">\n  <div class=\"passengers-dialog__close\" (click)=\"close()\">X</div>\n  <div class=\"passengers-dialog__triangle\"></div>\n  <div class=\"passengers-dialog__content\">\n    <ng-container [ngSwitch]=\"currentDialogType\">\n      <ng-container *ngSwitchCase=\"'guests'\">\n        <ng-container *ngTemplateOutlet=\"guestsTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'flights'\">\n        <ng-container *ngTemplateOutlet=\"flightsTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'assistance'\">\n        <ng-container *ngTemplateOutlet=\"assistanceTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'cruises'\">\n        <ng-container *ngTemplateOutlet=\"cruisesTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'circuits'\">\n        <ng-container *ngTemplateOutlet=\"circuitsTemplate; context: context\"></ng-container>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <p>Invalid dialog type</p>\n      </ng-container>\n    </ng-container>\n  </div>\n  <div class=\"passengers-dialog__footer\">\n    <hr />\n    <button (click)=\"handleDoneButtonClick()\" class=\"done-button\" color=\"secondary\" data-au=\"done\"\n      i18n=\"@@passengersDialog-ok\" mb-button variant=\"principal\">Listo</button>\n  </div>\n</div>\n\n<!-- Guests -->\n<ng-template #guestsTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.roomsChange($event)\" [(ngModel)]=\"ctrl.selectedRooms\"\n      [maxValue]=\"ctrl.statics.MAX_ROOMS\" [minValue]=\"ctrl.statics.MIN_ROOMS\" data-au=\"room\"\n      i18n-title=\"@@passengersDialog-rooms\" title=\"Habitaciones\"></am-passengers-dialog-selector>\n  </div>\n  <div *ngFor=\"let room of ctrl.rooms; let roomIndex = index; let last = last\" class=\"selector__wrapper\">\n    <hr />\n    <am-label-message [secondary]=\"true\" i18n=\"@@passengersDialog-guestsForRoom\">\n      <span>Habitaci\u00F3n {{ roomIndex + 1 }}</span>\n    </am-label-message>\n    <div class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'adults', $event)\" [(ngModel)]=\"room.adults\"\n        [maxValue]=\"ctrl.statics.MAX_ADULTS\" [minValue]=\"ctrl.statics.MIN_ADULTS\" attr.data-au=\"adults-{{ roomIndex }}\"\n        helpText=\"A partir de 18 a\u00F1os*\" i18n-helpText=\"@@passengersDialog-from18Age\"\n        i18n-title=\"@@passengersDialog-adult\" title=\"Mayores\"></am-passengers-dialog-selector>\n    </div>\n    <div class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'children', $event)\"\n        [(ngModel)]=\"room.children\" [maxValue]=\"ctrl.statics.MAX_CHILDREN\" [minValue]=\"ctrl.statics.MIN_CHILDREN\"\n        attr.data-au=\"children-{{ roomIndex }}\" helpText=\"Hasta 17 a\u00F1os\" i18n-helpText=\"@@passengersDialog-to17Age\"\n        i18n-title=\"@@passengersDialog-menores\" title=\"Menores\"></am-passengers-dialog-selector>\n    </div>\n    <div class=\"selector__messages\">\n      <am-label-message *ngIf=\"ctrl.showMaxPassengersAlert[roomIndex]\" defaultType=\"info\"\n        i18n=\"@@passengersDialog-maxGuestsReachedAlert\">L\u00EDmite de personas por habitaci\u00F3n alcanzado.</am-label-message>\n    </div>\n    <div *ngIf=\"ctrl.rooms[roomIndex].children\" class=\"selector\">\n      <div class=\"selector__messages\">\n        <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-guestChildAge\">Edad que tendr\u00E1 al finalizar el\n          viaje.</am-label-message>\n      </div>\n      <ng-container *ngFor=\"let child of room.childrenAges; let childIndex = index; let last = last\">\n        <div [ngClass]=\"{ last: last }\" class=\"selector__container\">\n          <mb-form-field appearance=\"light\">\n            <label for=\"child-{{ childIndex }}\" mb-form-field-label i18n=\"@@passengersDialog-menorAge\">Edad del menor\n              *</label>\n            <select #selector=\"ngModel\" (change)=\"ctrl.guestsChange(roomIndex, childIndex, child.value)\"\n              [(ngModel)]=\"child.value\" [childIndex]=\"childIndex\" [context]=\"ctrl\" [roomIndex]=\"roomIndex\" [room]=\"room\"\n              [selectorChanges]=\"!(value$ | async)\" amValidateSelector attr.data-au=\"age-child-{{ roomIndex }}\"\n              class=\"age-selector\" id=\"child-{{ childIndex }}\" mb-form-field-input role=\"listbox\" tabindex=\"0\"\n              validateSelector=\"guests\">\n              <option disabled hidden i18n=\"@@passengersDialog-selectAge\" selected value>Selecciona la edad</option>\n              <option *ngFor=\"let option of ctrl.statics.CHILDREN_AGES; let optionIndex = index\" [value]=\"optionIndex\">\n                {{ option }}</option>\n            </select>\n            <ng-container>\n              <mb-success *ngIf=\"selector.valid\"></mb-success>\n            </ng-container>\n\n            <mb-error *ngIf=\"(ctrl.dialogIsDirty && selector.invalid) || (selector.dirty && selector.invalid)\">\n              <ng-container *ngIf=\"selector.errors?.selectorRequired\"\n                i18n=\"@@passengersDialog-requiredErrorMessage\">Este campo es obligatorio</ng-container>\n\n              <ng-container *ngIf=\"selector.errors?.adultPerChild\"\n                i18n=\"@@passengersDialog-adultPerChildErrorMessage\">Debe viajar 1 adulto por menor</ng-container>\n            </mb-error>\n          </mb-form-field>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- Circuits -->\n<ng-template #circuitsTemplate let-ctrl>\n  <div class=\"selector selector--hr\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.roomsChange($event)\" [(ngModel)]=\"ctrl.selectedRooms\"\n      [maxValue]=\"ctrl.maxRooms()\" [minValue]=\"ctrl.statics.MIN_ROOMS\" data-au=\"room\"\n      i18n-title=\"@@passengersDialog-rooms\" title=\"Habitaciones\">\n    </am-passengers-dialog-selector>\n    <div class=\"nessages\">\n      <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-maxOccupation\">Hasta {{\n        ctrl.statics.MAX_PASSENGERS_PER_ROOM }} personas por habitaci\u00F3n.</am-label-message>\n    </div>\n  </div>\n  <ng-container *ngFor=\"let room of ctrl.rooms; let roomIndex = index\">\n    <hr />\n    <am-label-message [secondary]=\"true\" i18n=\"@@passengersDialog-guestsForRoom\">\n      <span>Habitaci\u00F3n {{ roomIndex + 1 }}</span>\n    </am-label-message>\n    <div [ngClass]=\"{ 'selector--without-message': !(room.adults === 1 && room.children === 0) }\" class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'adults', $event)\" [(ngModel)]=\"room.adults\"\n        [maxValue]=\"ctrl.maxAdults(roomIndex)\" [minValue]=\"ctrl.statics.MIN_ADULTS\"\n        attr.data-au=\"adults-{{ roomIndex }}\" helpText=\"A partir de 18 a\u00F1os*\"\n        i18n-helpText=\"@@passengersDialog-from18Age\" i18n-title=\"@@passengersDialog-adult\" title=\"Mayores\">\n      </am-passengers-dialog-selector>\n    </div>\n    <div *ngIf=\"room.adults === 1 && room.children === 0\" class=\"shared-room\">\n      <label class=\"shared-room__checkbox\">\n        <mb-checkbox [(ngModel)]=\"room.shared\" attr.data-au=\"shared-{{ roomIndex }}\"></mb-checkbox>\n        <span i18n=\"@@passengersDialog-sharingRoom\">Compartir habitaci\u00F3n con alguien del mismo sexo</span>\n      </label>\n    </div>\n    <div class=\"selector\">\n      <am-passengers-dialog-selector (change)=\"ctrl.guestsChange(roomIndex, 'children', $event)\"\n        [(ngModel)]=\"room.children\" [maxValue]=\"ctrl.maxChildren(roomIndex)\" [minValue]=\"ctrl.statics.MIN_CHILDREN\"\n        attr.data-au=\"children-{{ roomIndex }}\" i18n-title=\"@@passengersDialog-menores\" title=\"Menores\"\n        helpText=\"Hasta 17 a\u00F1os\" i18n-helpText=\"@@passengersDialog-to17Age\">\n      </am-passengers-dialog-selector>\n    </div>\n    <div *ngIf=\"ctrl.rooms[roomIndex].children\" class=\"selector\">\n      <div class=\"selector__messages\">\n        <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-guestChildAge\">Edad que tendr\u00E1 al finalizar el\n          viaje.</am-label-message>\n      </div>\n      <ng-container *ngFor=\"let child of room.childrenAges; let childIndex = index; let last = last\">\n        <div [ngClass]=\"{ last: last }\" class=\"selector__container\">\n          <mb-form-field appearance=\"light\">\n            <label for=\"child-{{ childIndex }}\" mb-form-field-label i18n=\"@@passengersDialog-menorAge\">Edad del\n              menor</label>\n            <select #selector=\"ngModel\" (change)=\"ctrl.updateDirtyStatus()\" [(ngModel)]=\"child.value\" [context]=\"ctrl\"\n              [selectorChanges]=\"!(value$ | async)\" amValidateSelector attr.data-au=\"age-child-{{ roomIndex }}\"\n              class=\"age-selector\" id=\"child-{{ childIndex }}\" mb-form-field-input role=\"listbox\" tabindex=\"0\">\n              <option disabled hidden i18n=\"@@passengersDialog-selectAge\" selected value>Selecciona la edad</option>\n              <option *ngFor=\"let option of ctrl.statics.CHILDREN_AGES; let optionIndex = index\" [value]=\"optionIndex\">\n                {{ option }}</option>\n            </select>\n            <ng-container>\n              <mb-success *ngIf=\"selector.valid\"></mb-success>\n            </ng-container>\n\n            <mb-error *ngIf=\"(ctrl.dialogIsDirty && selector.invalid) || (selector.dirty && selector.invalid)\">\n              <ng-container *ngIf=\"selector.errors?.selectorRequired\"\n                i18n=\"@@passengersDialog-requiredErrorMessage\">Este campo es obligatorio</ng-container>\n            </mb-error>\n          </mb-form-field>\n        </div>\n      </ng-container>\n    </div>\n  </ng-container>\n</ng-template>\n\n<!-- Flights -->\n<ng-template #flightsTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.adultsChange($event)\" [(ngModel)]=\"ctrl.adults\"\n      [maxValue]=\"ctrl.maxAdults\" [minValue]=\"ctrl.statics.MIN_ADULTS\" data-au=\"adults\" helpText=\"A partir de 18 a\u00F1os*\"\n      i18n-helpText=\"@@passengersDialog-from18Age\" i18n-title=\"@@passengersDialog-newAdults\" title=\"Adultos\"\n      role=\"dialog\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.youngAdultsChange($event)\" [(ngModel)]=\"ctrl.youngAdults\"\n      [maxValue]=\"ctrl.maxYoungAdults\" [minValue]=\"ctrl.statics.MIN_YOUNG_ADULTS\" data-au=\"youngAdults\"\n      helpText=\"De 12 a 17 a\u00F1os\" i18n-helpText=\"@@passengersDialog-from12To17Age\"\n      i18n-title=\"@@passengersDialog-youngAdults\" title=\"Adultos j\u00F3venes\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.childrenChange($event)\" [(ngModel)]=\"ctrl.children\"\n      [maxValue]=\"ctrl.maxChildren\" [minValue]=\"ctrl.statics.MIN_CHILDREN\" data-au=\"children\" helpText=\"De 2 a 11 a\u00F1os\"\n      i18n-helpText=\"@@passengersDialog-children\" i18n-title=\"@@passengersDialog-childrenTitle\" title=\"Ni\u00F1os\">\n    </am-passengers-dialog-selector>\n  </div>\n\n\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.babiesChange($event)\" [(ngModel)]=\"ctrl.babies\"\n      [maxValue]=\"ctrl.maxBabies\" [minValue]=\"ctrl.statics.MIN_BABIES\" [error]=\"ctrl.BabiesValidation\" data-au=\"babies\"\n      helpText=\"Menos de 2 a\u00F1os*\" i18n-helpText=\"@@passengersDialog-lessThan2\" i18n-title=\"@@passengersDialog-babies\"\n      title=\"Beb\u00E9s\">\n    </am-passengers-dialog-selector>\n  </div>\n  <ng-container>\n    <div class=\"flights_messages\">\n      <div *ngIf=\"ctrl.BabiesValidation\" class=\"flights_messages--item maxPerAdult\">\n        <mb-icon icon=\"PassengersDialog:close\"></mb-icon>\n        <span i18n=\"@@passengersDialog-maxAdultsPerBabies\" class=\"flights_messages--text\">Debe viajar 1 adulto por\n          bebe.</span>\n      </div>\n      <div *ngIf=\"ctrl.babies\" class=\"flights_messages--item info\">\n        <mb-icon icon=\"PassengersDialog:info\"></mb-icon>\n        <span i18n=\"@@passengersDialog-guestChildAge\" class=\"flights_messages--text\">Edad que tendr\u00E1 al finalizar el\n          viaje.</span>\n      </div>\n      <div *ngIf=\"ctrl.showMaxPassengersAlert\" class=\"flights_messages--item info\">\n        <mb-icon icon=\"PassengersDialog:info\"></mb-icon>\n        <span i18n=\"@@passengersDialog-maxPassengerReachedaAlert\" class=\"flights_messages--text\">Hasta {{\n          ctrl.statics.MAX_PASSENGERS }} personas por reserva.</span>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>\n\n<!-- Cruises-->\n<ng-template #cruisesTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.adultsChange($event)\" [(ngModel)]=\"ctrl.adults\"\n      [maxValue]=\"ctrl.maxAdults\" [minValue]=\"ctrl.statics.MIN_ADULTS\" data-au=\"adults\" helpText=\"A partir de 18 a\u00F1os*\"\n      i18n-helpText=\"@@passengersDialog-from18Age\" i18n-title=\"@@passengersDialog-adult\" title=\"Mayores\" role=\"dialog\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.childrenChange($event)\" [(ngModel)]=\"ctrl.children\"\n      [maxValue]=\"ctrl.maxChildren\" [minValue]=\"ctrl.statics.MIN_CHILDREN\" data-au=\"children\" helpText=\"De 2 a 17 a\u00F1os*\"\n      i18n-helpText=\"@@passengersDialog-from2To17Age\" i18n-title=\"@@passengersDialog-menores\" title=\"Menores\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div *ngIf=\"ctrl.children\" class=\"selector last\">\n    <am-label-message defaultType=\"info\" i18n=\"@@passengersDialog-guestChildAge\">\n      Edad que tendr\u00E1 al finalizar el viaje.</am-label-message>\n    <ng-container *ngFor=\"let child of ctrl.childrenAges; let childIndex = index\">\n      <div class=\"selector__container\">\n        <mb-form-field appearance=\"light\">\n          <label for=\"child-{{ childIndex }}\" mb-form-field-label i18n=\"@@passengersDialog-menorAge\">Edad del\n            menor</label>\n          <select #selector=\"ngModel\" (change)=\"ctrl.updateDirtyStatus()\" [(ngModel)]=\"child.value\" [context]=\"ctrl\"\n            [selectorChanges]=\"!(value$ | async)\" amValidateSelector class=\"age-selector\" data-au=\"age-child\"\n            id=\"child-{{ childIndex }}\" mb-form-field-input role=\"listbox\" tabindex=\"0\">\n            <option disabled hidden i18n=\"@@passengersDialog-selectAge\" selected value>Selecciona la edad\n            </option>\n            <option *ngFor=\"let option of ctrl.statics.CHILDREN_AGES; let optionIndex = index\" [value]=\"optionIndex\">{{\n              option }}</option>\n          </select>\n          <ng-container>\n            <mb-success *ngIf=\"selector.valid\"></mb-success>\n          </ng-container>\n\n          <mb-error *ngIf=\"(ctrl.dialogIsDirty && selector.invalid) || (selector.dirty && selector.invalid)\">\n            <ng-container *ngIf=\"selector.errors?.selectorRequired\" i18n=\"@@passengersDialog-requiredErrorMessage\">Este\n              campo es obligatorio</ng-container>\n          </mb-error>\n        </mb-form-field>\n      </div>\n    </ng-container>\n  </div>\n\n  <div class=\"selector__messages\">\n    <am-label-message *ngIf=\"ctrl.isCruises\" defaultType=\"info\" i18n=\"@@passengersDialog-maxOccupationPassengers\">Hasta\n      {{ ctrl.statics.MAX_PASSENGERS }} pasajeros.</am-label-message>\n  </div>\n</ng-template>\n\n<!-- Assistance -->\n<ng-template #assistanceTemplate let-ctrl>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector #selectorWrapper (change)=\"ctrl.passengersChange('young', $event)\"\n      [(ngModel)]=\"ctrl.young\" [maxValue]=\"ctrl.maxYoung\" [minValue]=\"ctrl.minYoung\" data-au=\"young\"\n      helpText=\"De 0 a 20 a\u00F1os\" i18n-helpText=\"@@passengersDialog-from0To20Age\" i18n-title=\"@@passengersDialog-young\"\n      title=\"J\u00F3venes\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.passengersChange('adults', $event)\" [(ngModel)]=\"ctrl.adults\"\n      [maxValue]=\"ctrl.maxAdults\" [minValue]=\"ctrl.minAdults\" data-au=\"adults\" helpText=\"De 21 a 69 a\u00F1os\"\n      i18n-helpText=\"@@passengersDialog-from21To69Age\" i18n-title=\"@@passengersDialog-adults\" title=\"Adultos\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector\">\n    <am-passengers-dialog-selector (change)=\"ctrl.passengersChange('oldPeople', $event)\" [(ngModel)]=\"ctrl.oldPeople\"\n      [maxValue]=\"ctrl.maxOldPeople\" [minValue]=\"ctrl.minOldPeople\" data-au=\"oldPeople\" helpText=\"+70 a\u00F1os\"\n      i18n-helpText=\"@@passengersDialog-mais70Age\" i18n-title=\"@@passengersDialog-older\" title=\"Mayores\">\n    </am-passengers-dialog-selector>\n  </div>\n  <div class=\"selector last--icon\">\n    <am-label-message *ngIf=\"ctrl.showMaxPassengersAlert\" defaultType=\"info\"\n      i18n=\"@@passengersDialog-maxPassengerReachedaAlert\">Hasta {{ ctrl.maxPassengers }} personas por\n      reserva.</am-label-message>\n  </div>\n</ng-template>\n", styles: ["@media only screen and (max-width: 767px){::ng-deep .am-panel-passengers-dialog{inset:0!important;position:absolute!important}}:host .passengers-dialog{background-color:var(--color-white);border:solid 1px var(--color-gray);border-radius:4px;display:flex;flex-direction:column;margin:8px 0;padding:16px;position:relative;width:290px}:host .passengers-dialog__triangle{border-bottom:7px solid var(--color-gray);border-left:12px solid transparent;border-right:12px solid transparent;height:0;left:5px;position:absolute;top:-7px;width:0}:host .passengers-dialog__triangle:before{border-bottom:6px solid var(--color-white);border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:0;left:-10px;position:absolute;top:1px;width:0}@media only screen and (max-width: 767px){:host .passengers-dialog__triangle{display:none}}:host .passengers-dialog hr{border:.0315rem solid var(--color-gray);margin:0 0 15px;width:100%}:host .passengers-dialog hr.last{margin-bottom:15px}:host .passengers-dialog__close{display:none}@media only screen and (max-width: 767px){:host .passengers-dialog__close{align-self:flex-start;cursor:pointer;display:block;font-size:1.3rem;font-weight:400;line-height:1;margin-bottom:10px}}@media only screen and (max-width: 767px){:host .passengers-dialog__content{overflow-y:scroll;padding-bottom:70px}}:host .passengers-dialog.circuits .shared-room{align-items:center;display:flex;font-size:.875rem;margin-bottom:5px}:host .passengers-dialog.circuits .shared-room__checkbox{display:flex}:host .passengers-dialog .selector{margin-bottom:15px}:host .passengers-dialog .selector__container{margin-bottom:15px}:host .passengers-dialog .selector__container.last{margin-bottom:0}:host .passengers-dialog .selector--without-message{margin-bottom:5px}:host .passengers-dialog .selector--hr{margin-bottom:10px}:host .passengers-dialog .selector.last{margin-bottom:0}:host .passengers-dialog .selector.last--icon{margin-bottom:10px}:host .passengers-dialog .flights_messages{margin-top:-7px;margin-bottom:19px}:host .passengers-dialog .flights_messages--item{display:flex;align-items:center;margin:6px 0}:host .passengers-dialog .flights_messages--item:first-child{margin-top:0}:host .passengers-dialog .flights_messages--item:last-child{margin-bottom:0}:host .passengers-dialog .flights_messages .maxPerAdult{color:var(--color-error);margin-bottom:4px}:host .passengers-dialog .flights_messages .info mb-icon{color:var(--color-notification-dark)}:host .passengers-dialog .flights_messages--text{margin-left:4px;font-size:14px}:host .passengers-dialog__footer{align-items:center;display:flex;flex-direction:column;justify-content:center}:host .passengers-dialog__footer .done-button{min-width:112px}:host .passengers-dialog__footer .done-button:focus,:host .passengers-dialog__footer .done-button--focus{border:3px solid var(--color-secondary-light);outline:none}@media only screen and (max-width: 767px){:host .passengers-dialog__footer{background-color:var(--color-white);bottom:16px;left:16px;position:absolute;right:16px}}@media only screen and (max-width: 767px){:host .passengers-dialog{border-radius:0;height:100%;margin:0;width:100%}}@media only screen and (max-width: 767px){:host{width:100%}}\n"] }]
        }], propDecorators: { keydown: [{
                type: HostListener,
                args: ["keydown", ["$event"]]
            }], queryList: [{
                type: ViewChildren,
                args: ["selectorWrapper", { read: ElementRef }]
            }] } });

const MINIMUM_CHILD_AGE = 2;
class GuestsDialogType {
    constructor() {
        this.statics = {
            MIN_ROOMS: 1,
            MAX_ROOMS: 4,
            MIN_ADULTS: 1,
            MAX_ADULTS: 10,
            MIN_CHILDREN: 0,
            MAX_CHILDREN: 8,
            CHILDREN_AGES: [
                // @TODO Añadir i18n
                "Entre 0 y 12 meses",
                ...Array(17)
                    .fill(null)
                    .map((_, index) => index + 1)
            ]
        };
        /**
         * Selected room
         */
        this.selectedRooms = this.statics.MIN_ROOMS;
        /**
         * Rooms
         */
        this.rooms = [
            {
                adults: this.statics.MIN_ADULTS,
                children: this.statics.MIN_CHILDREN,
                childrenAges: []
            }
        ];
        /**
         * Indicate if dialog form is dirty
         */
        this.dialogIsDirty = false;
        /**
         * Executed when rooms change
         * @param newRooms selected room
         */
        this.roomsChange = newRooms => {
            const currentRooms = this.rooms.length;
            if (currentRooms > newRooms) {
                this.rooms.splice(newRooms);
            }
            else if (currentRooms < newRooms) {
                this.rooms.push({ adults: 0, children: 0, childrenAges: [] });
            }
            const { rooms } = this;
            this.propagateChanges({ selectedRooms: newRooms, rooms });
        };
        /**
         * Set value to guests
         * @param room Room index
         * @param guest guest attribute
         * @param value value
         */
        this.guestsChange = (room, guest, value) => {
            this.rooms[room][guest] = value;
            this.updateChildrenAgesArray(room);
            const { rooms, selectedRooms } = this;
            this.propagateChanges({ selectedRooms, rooms });
        };
        /**
         * Update status of dialog
         */
        this.updateDirtyStatus = () => {
            if (this.dialogIsDirty) {
                this.dialogIsDirty = this.agesSelectorHasError();
            }
        };
    }
    /**
     * indicate if show max guests alert
     */
    get showMaxPassengersAlert() {
        return this.rooms.map(room => this.options.showMaxPassengersAlert &&
            room.adults >= this.statics.MAX_ADULTS &&
            room.children >= this.statics.MAX_CHILDREN);
    }
    /**
     * Get infants
     */
    get infants() {
        return this.rooms.map(room => room.childrenAges.reduce((accumulated, current, index) => {
            const infant = current.value < MINIMUM_CHILD_AGE ? [index] : [];
            return [...accumulated, ...infant];
        }, []));
    }
    /**
     * @inheritDoc
     */
    getType() {
        return "guests";
    }
    /**
     * @inheritDoc
     */
    setValue(value = {}) {
        if (value.selectedRooms) {
            this.selectedRooms = value.selectedRooms || this.statics.MIN_ROOMS;
        }
        if (value.rooms && Array.isArray(value.rooms)) {
            this.rooms = value.rooms.map(room => {
                return {
                    adults: room.adults || this.statics.MIN_ADULTS,
                    children: room.children || this.statics.MIN_CHILDREN,
                    childrenAges: room.childrenAges ||
                        (room.children ? Array(room.children).fill({ value: "" }) : [])
                };
            });
        }
    }
    /**
     * @inheritDoc
     */
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    /**
     * @inheritDoc
     */
    getInputValue() {
        const count = this.rooms
            .map(({ adults = 0, children = 0 }) => adults + children)
            .reduce((total, room) => total + room, 0);
        // @TODO Añadir i18n
        return `${count}`;
    }
    /**
     * @inheritDoc
     */
    canClose() {
        const hasAdultPerInfant = this.options && this.options.adultPerInfant
            ? !this.infants.find((infants, room) => infants.length > this.rooms[room].adults)
            : true;
        const selectorHasError = this.agesSelectorHasError();
        this.dialogIsDirty = selectorHasError;
        return hasAdultPerInfant && !selectorHasError;
    }
    /**
     *
     * @inheritDoc
     */
    validate() {
        const hasAdultPerInfant = this.options && this.options.adultPerInfant
            ? !this.infants.find((infants, room) => infants.length > this.rooms[room].adults)
            : true;
        const selectorHasError = this.agesSelectorHasError();
        let err = null;
        if (selectorHasError) {
            err = { "child-age-required": true };
        }
        else if (!hasAdultPerInfant) {
            err = { "adult-for-infant": true };
        }
        return err;
    }
    /**
     * @inheritDoc
     */
    setOptions(options) {
        this.options = options;
    }
    /**
     * Update the children ages array values
     * @param room room index
     */
    updateChildrenAgesArray(room) {
        const children = this.rooms[room].children;
        const childrenAges = this.rooms[room].childrenAges;
        if (childrenAges.length > children) {
            childrenAges.splice(children);
        }
        else {
            childrenAges.push(...Array(children - childrenAges.length).fill({ value: "" }));
        }
        if (this.dialogIsDirty) {
            this.dialogIsDirty = this.agesSelectorHasError();
        }
    }
    /**
     * Indicates if some age selector has error
     */
    agesSelectorHasError() {
        const errors = this.rooms.filter(room => {
            return (room.childrenAges.filter(item => !item.value && item.value !== 0)
                .length > 0);
        });
        return Boolean(errors.length);
    }
}

class FlightsDialogType {
    constructor() {
        this.statics = {
            MAX_PASSENGERS: 9,
            MIN_ADULTS: 1,
            MIN_BABIES: 0,
            MIN_CHILDREN: 0,
            MIN_YOUNG_ADULTS: 0,
        };
        /**
         * Number of adults
         */
        this.adults = this.statics.MIN_ADULTS;
        this.youngAdults = this.statics.MIN_YOUNG_ADULTS;
        /**
         * Number of children
         */
        this.children = this.statics.MIN_CHILDREN;
        /**
         * Number of children
         */
        this.babies = this.statics.MIN_BABIES;
        /**
         * Indicate if dialog is dirty
         */
        this.dialogIsDirty = false;
        /**
         * Update status of dialog
         */
        this.updateDirtyStatus = () => {
            if (this.dialogIsDirty) {
                this.dialogIsDirty = this.babiesSelectedError();
            }
            this.propagateChanges({
                adults: this.adults,
                youngAdults: this.youngAdults,
                children: this.children,
            });
        };
    }
    /**
     * Get max adults allowed
     */
    get maxAdults() {
        return (this.statics.MAX_PASSENGERS -
            this.youngAdults -
            this.children -
            this.babies);
    }
    /**
     * indicate if show max passenger alert
     */
    get showMaxPassengersAlert() {
        return (this.options.showMaxPassengersAlert &&
            this.adults + this.youngAdults + this.children + this.babies >=
                this.statics.MAX_PASSENGERS);
    }
    /**
     * Get max chi,dren allowed
     */
    get maxChildren() {
        return (this.statics.MAX_PASSENGERS - this.adults - this.youngAdults - this.babies);
    }
    get maxYoungAdults() {
        return (this.statics.MAX_PASSENGERS - this.adults - this.children - this.babies);
    }
    /**
     * Get max babies allowed
     */
    get maxBabies() {
        return (this.statics.MAX_PASSENGERS -
            this.adults -
            this.youngAdults -
            this.children);
    }
    /**
     * Determines if the number of adults and young adults is less than the number of babies,
     * considering the option of one adult per infant.
     *
     * @returns boolean True if the number of adults and young adults is less than the number of babies,
     * considering the option of one adult per infant. False otherwise.
     */
    get BabiesValidation() {
        return this.options.adultPerInfant && this.adults < this.babies;
    }
    /**
     * Get infants
     */
    get infants() {
        return this.children;
    }
    /**
     * @inheritDoc
     */
    canClose() {
        const selectorHasError = this.babiesSelectedError();
        this.dialogIsDirty = selectorHasError;
        return !selectorHasError && !this.BabiesValidation;
    }
    /**
     *
     * @inheritDoc
     */
    validate() {
        const err = {};
        if (this.babiesSelectedError()) {
            err["adult-for-infant"] = true;
        }
        return Object.keys(err).length === 0 ? null : err;
    }
    /**
     * @inheritDoc
     */
    setOptions(options) {
        this.options = options;
    }
    /**
     * @inheritDoc
     */
    getInputValue() {
        const count = this.adults + this.youngAdults + this.children + this.babies;
        // @TODO Añadir i18n
        return `${count}`;
    }
    /**
     * @inheritDoc
     */
    getType() {
        return "flights";
    }
    /**
     * @inheritDoc
     */
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    /**
     * @inheritDoc
     */
    setValue(value = {}) {
        this.adults = value.adults || this.statics.MIN_ADULTS;
        this.children = value.children || this.statics.MIN_CHILDREN;
        this.babies = value.babies || this.statics.MIN_BABIES;
        this.youngAdults = value.youngAdults || this.statics.MIN_YOUNG_ADULTS;
    }
    /**
     * Called when adults selector change
     * @param adults value
     */
    adultsChange(adults) {
        this.adults = adults;
        this.propagateChanges({
            adults,
            babies: this.babies,
            children: this.children,
            youngAdults: this.youngAdults,
        });
    }
    /**
     * Called when children selector change
     * @param children value
     */
    childrenChange(children) {
        this.children = children;
        this.propagateChanges({
            adults: this.adults,
            babies: this.babies,
            children,
            youngAdults: this.youngAdults,
        });
    }
    /**
     * Called when children selector change
     * @param youngAdults value
     */
    youngAdultsChange(youngAdults) {
        this.youngAdults = youngAdults;
        this.propagateChanges({
            adults: this.adults,
            babies: this.babies,
            children: this.children,
            youngAdults,
        });
    }
    /**
     * Called when babies selector change
     * @param babies value
     */
    babiesChange(babies) {
        this.babies = babies;
        this.propagateChanges({
            adults: this.adults,
            babies,
            children: this.children,
            youngAdults: this.youngAdults,
        });
    }
    babiesSelectedError() {
        return this.babies >= 1 && this.babies > this.adults;
    }
}

class CircuitsDialogType {
    constructor() {
        this.statics = {
            MIN_ROOMS: 1,
            SHARED: false,
            MAX_ROOMS: 11,
            MAX_PASSENGERS: 12,
            MAX_PASSENGERS_PER_ROOM: 3,
            MIN_ADULTS: 1,
            MAX_ADULTS: 10,
            MIN_CHILDREN: 0,
            MAX_CHILDREN: 8,
            CHILDREN_AGES: [
                // @TODO Añadir i18n
                "Entre 0 y 12 meses",
                ...Array(17)
                    .fill(null)
                    .map((_, index) => index + 1),
            ],
        };
        /**
         * Selected room
         */
        this.selectedRooms = this.statics.MIN_ROOMS;
        /**
         * Participants count
         */
        this.participantsCount = 0;
        /**
         * Rooms
         */
        this.rooms = [
            {
                adults: this.statics.MIN_ADULTS,
                shared: this.statics.SHARED,
                children: this.statics.MIN_CHILDREN,
                childrenAges: [],
            },
        ];
        /**
         * Indicate if dialog form is dirty
         */
        this.dialogIsDirty = false;
        /**
         * Number of adults
         */
        this.adults = this.statics.MIN_ADULTS;
        /**
         * Number of children
         */
        this.children = this.statics.MIN_CHILDREN;
        /**
         * Executed when rooms change
         * @param newRooms amount of rooms
         */
        this.roomsChange = (newRooms) => {
            const currentRooms = this.rooms.length;
            if (currentRooms > newRooms) {
                this.rooms.splice(newRooms);
            }
            else if (currentRooms < newRooms) {
                this.rooms.push({
                    adults: 0,
                    shared: false,
                    children: 0,
                    childrenAges: [],
                });
            }
            const { rooms } = this;
            this.propagateChanges({ selectedRooms: newRooms, rooms });
        };
        /**
         * Set value to guests
         * @param room Room index
         * @param guest guest attribute
         * @param value value
         */
        this.guestsChange = (room, guest, value) => {
            this.rooms[room][guest] = value;
            this.updateChildrenAgesArray(room);
            const { rooms, selectedRooms } = this;
            this.propagateChanges({ selectedRooms, rooms });
        };
        /**
         * Update status of dialog
         */
        this.updateDirtyStatus = () => {
            if (this.dialogIsDirty) {
                this.dialogIsDirty = this.agesSelectorHasError();
            }
        };
    }
    /**
     * indicate if show max passenger alert
     */
    get showMaxPassengersAlert() {
        const maxPassengersReached = !!this.rooms.find((room) => room.adults + room.children >= this.statics.MAX_PASSENGERS_PER_ROOM);
        return this.options.showMaxPassengersAlert && maxPassengersReached;
    }
    /**
     * @inheritDoc
     */
    getType() {
        return "circuits";
    }
    /**
     * @inheritDoc
     */
    setValue(value = {}) {
        if (value.selectedRooms) {
            this.selectedRooms = value.selectedRooms || this.statics.MIN_ROOMS;
        }
        if (value.rooms && Array.isArray(value.rooms)) {
            this.rooms = value.rooms.map((room) => {
                return {
                    adults: room.adults || this.statics.MIN_ADULTS,
                    children: room.children || this.statics.MIN_CHILDREN,
                    shared: room.shared || this.statics.SHARED,
                    childrenAges: room.childrenAges ||
                        (room.children ? Array(room.children).fill({ value: "" }) : []),
                };
            });
        }
    }
    /**
     * @inheritDoc
     */
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    /**
     * @inheritDoc
     */
    getInputValue() {
        const count = this.rooms
            .map(({ adults = 0, children = 0, shared = false }) => {
            return {
                participants: adults + children,
                shared: shared ? 1 : 0,
            };
        })
            .reduce((total, room) => {
            return {
                participants: total.participants + room.participants,
                shared: total.shared + room.shared,
            };
        });
        // @TODO Add i18n
        return `${count.participants}`;
    }
    /**
     * @inheritDoc
     */
    canClose() {
        const selectorHasError = this.agesSelectorHasError();
        this.dialogIsDirty = selectorHasError;
        return !selectorHasError;
    }
    validate() {
        const selectorHasError = this.agesSelectorHasError();
        let err = null;
        if (selectorHasError) {
            err = { "child-age-required": true };
        }
        return err;
    }
    /**
     * @inheritdoc
     */
    setOptions({ showMaxPassengersAlert }) {
        this.options = {
            showMaxPassengersAlert,
        };
    }
    getTotalPassengers() {
        return this.rooms.reduce((total, room) => {
            return (total += room.adults + room.childrenAges.length);
        }, 0);
    }
    /**
     * Get passengers total from all rooms less roomIndex
     * @param roomIndex: number
     */
    getTotalPassengersOtherRooms(roomIndex) {
        return this.rooms.reduce((total, room, currentIndex) => {
            return roomIndex === currentIndex
                ? total
                : (total += room.adults + room.childrenAges.length);
        }, 0);
    }
    getPassengersInRoom(room) {
        return room.adults + room.children;
    }
    maxRooms() {
        return this.getTotalPassengers() < this.statics.MAX_PASSENGERS
            ? this.rooms.length + 1
            : this.rooms.length;
    }
    getMaxPerRoom(roomIndex) {
        const passengersLeft = this.statics.MAX_PASSENGERS -
            this.getTotalPassengersOtherRooms(roomIndex);
        return this.statics.MAX_PASSENGERS_PER_ROOM <= passengersLeft
            ? this.statics.MAX_PASSENGERS_PER_ROOM
            : passengersLeft;
    }
    /**
     * Get max adults allowed
     */
    maxAdults(roomIndex) {
        return this.getMaxPerRoom(roomIndex) - this.rooms[roomIndex].children;
    }
    /**
     * Get max adults allowed
     */
    maxChildren(roomIndex) {
        return this.getMaxPerRoom(roomIndex) - this.rooms[roomIndex].adults;
    }
    /**
     * Update the children ages array values
     * @param room room index
     */
    updateChildrenAgesArray(room) {
        const children = this.rooms[room].children;
        const childrenAges = this.rooms[room].childrenAges;
        if (childrenAges.length > children) {
            childrenAges.splice(children);
        }
        else {
            childrenAges.push(...Array(children - childrenAges.length).fill({ value: "" }));
        }
        if (this.dialogIsDirty) {
            this.dialogIsDirty = this.agesSelectorHasError();
        }
    }
    /**
     * Indicates if some age selector has error
     */
    agesSelectorHasError() {
        const errors = this.rooms.filter((room) => {
            return (room.childrenAges.filter((item) => !item.value && item.value !== 0)
                .length > 0);
        });
        return Boolean(errors.length);
    }
}

const STATICS = {
    INITIAL_YOUNG: 0,
    INITIAL_ADULTS: 1,
    INITIAL_OLD_PEOPLE: 0,
    MIN_PASSENGERS: 1,
    MAX_PASSENGERS: 9
};
class AssistanceDialogType {
    constructor() {
        this.young = STATICS.INITIAL_YOUNG;
        this.adults = STATICS.INITIAL_ADULTS;
        this.oldPeople = STATICS.INITIAL_OLD_PEOPLE;
        this.maxPassengers = STATICS.MAX_PASSENGERS;
    }
    get minYoung() {
        return this.adults + this.oldPeople > 0 ? 0 : 1;
    }
    get maxYoung() {
        return STATICS.MAX_PASSENGERS - this.adults - this.oldPeople;
    }
    get minAdults() {
        return this.young + this.oldPeople > 0 ? 0 : 1;
    }
    get maxAdults() {
        return STATICS.MAX_PASSENGERS - this.young - this.oldPeople;
    }
    get minOldPeople() {
        return this.young + this.adults > 0 ? 0 : 1;
    }
    get maxOldPeople() {
        return STATICS.MAX_PASSENGERS - this.young - this.adults;
    }
    /**
     * indicate if show max passenger alert
     */
    get showMaxPassengersAlert() {
        return (this.options.showMaxPassengersAlert &&
            this.young + this.adults + this.oldPeople >= STATICS.MAX_PASSENGERS);
    }
    canClose() {
        return true;
    }
    validate() {
        return null;
    }
    /**
     * @inheritdoc
     */
    setOptions(options) {
        const { showMaxPassengersAlert } = options;
        this.options = {
            showMaxPassengersAlert
        };
    }
    getInputValue() {
        const count = this.young + this.adults + this.oldPeople;
        // @TODO Añadir i18n
        return `${count}`;
    }
    getType() {
        return "assistance";
    }
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    setValue(value) {
        const { young, adults, oldPeople } = value;
        this.young = young || STATICS.INITIAL_YOUNG;
        this.adults = adults || STATICS.INITIAL_ADULTS;
        this.oldPeople = oldPeople || STATICS.INITIAL_OLD_PEOPLE;
    }
    passengersChange(type, value) {
        if (!(type in this)) {
            throw new Error(`Type ${type} doesn't exist in this dialog`);
        }
        this[type] = value;
        const { young, adults, oldPeople } = this;
        this.propagateChanges({ young, adults, oldPeople });
    }
}

var CHILDREN_AGES;
(function (CHILDREN_AGES) {
    CHILDREN_AGES[CHILDREN_AGES["BETWEEN2AND11"] = 1] = "BETWEEN2AND11";
})(CHILDREN_AGES || (CHILDREN_AGES = {}));
class CruisesDialogType {
    constructor() {
        this.statics = {
            MIN_ADULTS: 1,
            MIN_CHILDREN: 0,
            MIN_BABIES: 0,
            MAX_PASSENGERS: 4,
            CHILDREN_AGES: [
                ...Array(13)
                    .fill(null)
                    .map((_, index) => index),
            ],
        };
        this.adults = this.statics.MIN_ADULTS;
        this.children = this.statics.MIN_CHILDREN;
        this.babies = this.statics.MIN_BABIES;
        this.childrenAges = [];
        this.dialogIsDirty = false;
        this.isCruises = true;
        this.updateDirtyStatus = () => {
            if (this.dialogIsDirty) {
                this.dialogIsDirty =
                    this.agesSelectorHasError() || this.babiesSelectedError();
            }
            this.propagateChanges({
                adults: this.adults,
                children: this.children,
                childrenAges: this.childrenAges,
            });
        };
    }
    get maxAdults() {
        return this.statics.MAX_PASSENGERS - this.children - this.babies;
    }
    get showMaxPassengersAlert() {
        return (this.options.showMaxPassengersAlert &&
            this.adults + this.children + this.babies >= this.statics.MAX_PASSENGERS);
    }
    get maxChildren() {
        return this.statics.MAX_PASSENGERS - this.adults - this.babies;
    }
    get maxBabies() {
        return this.statics.MAX_PASSENGERS - this.adults - this.children;
    }
    get BabiesValidation() {
        return this.options.adultPerInfant && this.adults < this.babies;
    }
    setOptions(options) {
        this.options = { ...options, adultPerInfant: false };
    }
    get infants() {
        return this.childrenAges.reduce((accumulated, current, index) => {
            const infant = current.value < CHILDREN_AGES.BETWEEN2AND11 ? [index] : [];
            return [...accumulated, ...infant];
        }, []);
    }
    canClose() {
        const selectorHasError = this.agesSelectorHasError() || this.babiesSelectedError();
        this.dialogIsDirty = selectorHasError;
        return !selectorHasError && !this.BabiesValidation;
    }
    validate() {
        const err = {};
        if (this.agesSelectorHasError()) {
            err["child-age-required"] = true;
        }
        if (this.babiesSelectedError()) {
            err["adult-for-infant"] = true;
        }
        return Object.keys(err).length === 0 ? null : err;
    }
    /**
     * @inheritDoc
     */
    getInputValue() {
        return `${this.adults + this.children + this.babies}`;
    }
    /**
     * @inheritDoc
     */
    getType() {
        return "cruises";
    }
    /**
     * @inheritDoc
     */
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    setValue(value = {}) {
        this.adults = value.adults || this.statics.MIN_ADULTS;
        this.children = value.children || this.statics.MIN_CHILDREN;
        this.babies = value.babies || this.statics.MIN_BABIES;
        this.childrenAges =
            value.childrenAges ||
                (value.children ? Array(value.children).fill({ value: "" }) : []);
    }
    adultsChange(adults) {
        this.adults = adults;
        this.updateChildrenAges(this.children);
        this.propagateChanges({
            adults,
            children: this.children,
            childrenAges: this.childrenAges,
            babies: this.babies,
        });
    }
    childrenChange(children) {
        this.children = children;
        this.updateChildrenAges(children);
        this.propagateChanges({
            adults: this.adults,
            children,
            childrenAges: this.childrenAges,
            babies: this.babies,
        });
        if (this.dialogIsDirty) {
            this.dialogIsDirty = this.agesSelectorHasError();
        }
    }
    babiesChange(babies) {
        this.babies = babies;
        this.updateChildrenAges(this.children);
        this.propagateChanges({
            adults: this.adults,
            children: this.children,
            childrenAges: this.childrenAges,
            babies,
        });
        if (this.dialogIsDirty) {
            this.dialogIsDirty = this.agesSelectorHasError();
        }
    }
    updateChildrenAges(children) {
        if (this.childrenAges.length > children) {
            this.childrenAges.splice(children);
        }
        else {
            this.childrenAges.push(...Array(children - this.childrenAges.length).fill({ value: "" }));
        }
        if (this.dialogIsDirty) {
            this.dialogIsDirty = this.agesSelectorHasError();
        }
    }
    agesSelectorHasError() {
        return (this.childrenAges.filter((item) => !item.value && item.value !== 0)
            .length > 0);
    }
    babiesSelectedError() {
        return this.babies >= 1 && this.babies > this.adults;
    }
}

class PassengersDialogDirective {
    /**
     * Returns current dialog type
     */
    get dialogType() {
        return this.types[this.type] || null;
    }
    /**
     * Sets disabled to control
     */
    set disabled(value) {
        this.isDisabled = value;
    }
    get disabled() {
        return this.isDisabled;
    }
    /**
     * Binds keydown enter(13), space(32), escape(27) event to input element
     * @param event keydown event
     */
    keydown(event) {
        const ENTER_KEY = 'Enter';
        const SPACE_KEY = 'Space';
        const ESCAPE_KEY = 'Escape';
        event.preventDefault();
        if (event.code === ENTER_KEY || event.code === SPACE_KEY) {
            if (!this.opened) {
                const allowFocus = true;
                this.opened = true;
                this.open(allowFocus);
            }
        }
        else if (event.code === ESCAPE_KEY && this.isOpen) {
            this.close();
        }
    }
    /**
     * Binds click event to input element
     */
    click() {
        if (!this.opened) {
            this.opened = true;
            this.open();
        }
    }
    validate() {
        return this.isOpen ? null : this.dialogType.validate();
    }
    constructor(element, renderer, overlay, changeDetector) {
        this.element = element;
        this.renderer = renderer;
        this.overlay = overlay;
        this.changeDetector = changeDetector;
        this.externalViewValueSubcription = new Subscription();
        /**
         * Indicates if is disabled
         */
        this.isDisabled = false;
        /**
         * Dialog status
         */
        this.isOpen = false;
        /**
         *  Dialog opened status
         */
        this.opened = false;
        /**
         * Availables dialog types
         */
        this.types = {
            guests: new GuestsDialogType(),
            flights: new FlightsDialogType(),
            assistance: new AssistanceDialogType(),
            cruises: new CruisesDialogType(),
            circuits: new CircuitsDialogType()
        };
        /**
         * Emits the value of the dialog when it changes and externalViewValue$ exists
         */
        this.dialogChanges = new EventEmitter();
    }
    ngOnInit() {
        // Set readonly attribute to prevent mobile keyboard to be opened on click
        this.renderer.setAttribute(this.element.nativeElement, 'readonly', 'true');
        const positionStrategy = this.getPositionStrategy();
        this.overlayDialog = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            backdropClass: 'am-overlay-passengers-dialog-backdrop',
            panelClass: 'am-panel-passengers-dialog',
            hasBackdrop: true
        });
        this.overlayDialogBackdropClickObserver = this.overlayDialog
            .backdropClick()
            .subscribe(() => {
            this.close();
        });
        this.dialogPortal = new ComponentPortal(PassengersDialogComponent);
    }
    ngAfterViewInit() {
        if (this.externalViewValue$) {
            this.updateInputValueViewFromOutside();
        }
    }
    ngOnDestroy() {
        this.overlayDialogBackdropClickObserver.unsubscribe();
        this.externalViewValueSubcription.unsubscribe();
    }
    /**
     * Open passengers dialog
     */
    open(allowFocus = false) {
        this.isOpen = true;
        const dialogType = this.dialogType;
        const dialog = this.dialogPortal.attach(this.overlayDialog);
        dialog.instance.allowFocus = allowFocus;
        dialog.instance.value = this.value;
        dialog.instance.setType(dialogType, {
            showMaxPassengersAlert: this.showMaxPassengersAlert,
            adultPerInfant: this.enableAdultByInfant
        });
        dialog.instance.value$.subscribe(value => {
            this.value = value.value;
            this.propagateChanges(this.value);
            if (this.externalViewValue$) {
                this.dialogChanges.emit(value);
            }
            else {
                this.updateInput(value.inputValue);
            }
            this.changeDetector.detectChanges();
        });
        const closeObservable = dialog.instance.close$.subscribe(() => {
            this.close();
            closeObservable.unsubscribe();
        });
    }
    /**
     * Register callback function executed on change
     * @param fn callback executed on change
     */
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    registerOnTouched(fn) { }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    /**
     * Set model value
     * @param value value
     */
    writeValue(value) {
        if (value) {
            this.value = value;
            const dialogType = this.dialogType;
            if (dialogType) {
                dialogType.setValue(this.value);
                if (this.externalViewValue$) {
                    this.dialogChanges.emit(dialogType.getInputValue());
                }
                else {
                    this.updateInput(dialogType.getInputValue());
                }
            }
        }
    }
    getPositionStrategy() {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.element)
            .withLockedPosition()
            .withFlexibleDimensions(false)
            .withPositions([
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top'
            }
        ]);
    }
    /**
     * Close passengers dialog
     */
    close() {
        this.isOpen = false;
        this.opened = false;
        this.propagateChanges(this.value);
        this.dialogType.canClose();
        this.overlayDialog &&
            this.overlayDialog.hasAttached() &&
            this.overlayDialog.detach();
        this.dialogPortal &&
            this.dialogPortal.isAttached &&
            this.dialogPortal.detach();
    }
    updateInputValueViewFromOutside() {
        this.externalViewValueSubcription = this.externalViewValue$.subscribe({
            next: (value) => {
                const input = this.element.nativeElement;
                input.value = value;
                this.changeDetector.detectChanges();
            }
        });
    }
    /**
     * Updates input value
     * @param inputValue input value to update
     */
    updateInput(inputValue) {
        const input = this.element.nativeElement;
        input.value = `${inputValue} ${Number.parseInt(inputValue, 10) > 1 ? this.dual : this.unique}`;
    }
}
/** @nocollapse */ PassengersDialogDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$1.Overlay }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ PassengersDialogDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: PassengersDialogDirective, selector: "[amPassengersDialog]", inputs: { positionRelativeTo: "positionRelativeTo", type: "type", unique: "unique", dual: "dual", enableAdultByInfant: "enableAdultByInfant", showMaxPassengersAlert: "showMaxPassengersAlert", externalViewValue$: "externalViewValue$", disabled: "disabled" }, outputs: { dialogChanges: "dialogChanges" }, host: { listeners: { "keydown": "keydown($event)", "click": "click()" }, properties: { "disabled": "this.isDisabled" } }, providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef((() => PassengersDialogDirective)),
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => PassengersDialogDirective)),
            multi: true
        }
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amPassengersDialog]',
                    providers: [
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((() => PassengersDialogDirective)),
                            multi: true
                        },
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => PassengersDialogDirective)),
                            multi: true
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$1.Overlay }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { positionRelativeTo: [{
                type: Input
            }], isDisabled: [{
                type: HostBinding,
                args: ['disabled']
            }], type: [{
                type: Input
            }], unique: [{
                type: Input
            }], dual: [{
                type: Input
            }], enableAdultByInfant: [{
                type: Input
            }], showMaxPassengersAlert: [{
                type: Input
            }], externalViewValue$: [{
                type: Input
            }], disabled: [{
                type: Input
            }], dialogChanges: [{
                type: Output
            }], keydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], click: [{
                type: HostListener,
                args: ['click']
            }] } });

const ICON_NAMESPACE = "PassengersDialog";
class PassengersDialogModule {
    constructor(iconRegistry) {
        iconRegistry.addSvgIconDefinitionInNamespace(aciAdd, ICON_NAMESPACE);
        iconRegistry.addSvgIconDefinitionInNamespace(aciSub, ICON_NAMESPACE);
        iconRegistry.addSvgIconDefinitionInNamespace(aciClose, ICON_NAMESPACE);
        iconRegistry.addSvgIconDefinitionInNamespace(aciInfo, ICON_NAMESPACE);
    }
}
/** @nocollapse */ PassengersDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogModule, deps: [{ token: i3.MbIconRegistry }], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ PassengersDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogModule, declarations: [PassengersDialogComponent,
        PassengersDialogSelectorComponent,
        PassengersDialogDirective,
        LabelMessageComponent,
        SelectorValidatorDirective], imports: [CommonModule,
        FormsModule,
        OverlayModule,
        MbIconModule,
        MbCheckboxModule,
        MbButtonModule,
        MbFormFieldModule], exports: [PassengersDialogDirective] });
/** @nocollapse */ PassengersDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogModule, imports: [CommonModule,
        FormsModule,
        OverlayModule,
        MbIconModule,
        MbCheckboxModule,
        MbButtonModule,
        MbFormFieldModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PassengersDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PassengersDialogComponent,
                        PassengersDialogSelectorComponent,
                        PassengersDialogDirective,
                        LabelMessageComponent,
                        SelectorValidatorDirective,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        OverlayModule,
                        MbIconModule,
                        MbCheckboxModule,
                        MbButtonModule,
                        MbFormFieldModule,
                    ],
                    exports: [PassengersDialogDirective],
                    entryComponents: [PassengersDialogComponent],
                }]
        }], ctorParameters: function () { return [{ type: i3.MbIconRegistry }]; } });

/*
 * Public API Surface of passengers-dialog
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PassengersDialogDirective, PassengersDialogModule };
